import { useState } from "react";

function Faq() {
  const [activeQ, setActiveQ] = useState("q1");

  const openQ = (id) => {
    setActiveQ(activeQ === id ? "" : id);
  };

  const getClassAnswer = (id) => {
    return activeQ === id ? "active-answer" : "";
  };

  const getClassQuestion = (id) => {
    return activeQ === id ? "active-question" : "";
  };

  return (
    <>
      <section className="faq-section">
        <div className="container">
          <div className="faq-content">
            <div className="faq-content__title">
              <h5>FAQ</h5>
              <h2>Question frequement posées</h2>
                <p>
                  Foire aux questions sur le processus de réservation de voiture sur notre site :
                  réponses aux questions et préoccupations les plus courantes.
                </p>
            </div>

            <div className="all-questions">
              <div className="faq-box">
                <div
                  id="q1"
                  onClick={() => openQ("q1")}
                  className={`faq-box__question  ${getClassQuestion("q1")}`}
                >
                  <p>1. Qu’est-ce qui rend la comparaison des offres de location de voitures intéressante ?</p>
                  <i className="fa-solid fa-angle-down"></i>
                </div>
                <div
                  id="q1"
                  onClick={() => openQ("q1")}
                  className={`faq-box__answer ${getClassAnswer("q1")}`}
                >
                Comparer les offres de location de voitures est essentiel pour trouver celle
                qui correspond le mieux à votre budget et à vos besoins, tout en obtenant le
                meilleur rapport qualité-prix. En comparant plusieurs options, vous pouvez
                repérer des tarifs plus avantageux, des services supplémentaires ou des modèles
                de véhicules plus adaptés. Vous pouvez trouver les meilleures offres en
                effectuant des recherches en ligne et en comparant les prix proposés par
                différentes agences de location.
              </div>
              </div>
              <div className="faq-box">
                <div
                  id="q2"
                  onClick={() => openQ("q2")}
                  className={`faq-box__question ${getClassQuestion("q2")}`}
                >
                  <p>2. Comment puis-je trouver des offres de location de voiture ?</p>
                    <i className="fa-solid fa-angle-down"></i>
                    </div>

                    <div
                      id="q2"
                      onClick={() => openQ("q2")}
                      className={`faq-box__answer ${getClassAnswer("q2")}`}
                    >
                      Vous pouvez trouver des offres de location en effectuant des recherches en ligne
                      et en comparant les prix proposés par différentes agences. Des sites comme
                      Expedia, Kayak ou Travelocity permettent de comparer facilement les tarifs et
                      de consulter les options disponibles. Il est également conseillé de s’inscrire
                      aux newsletters et de suivre les agences de location sur les réseaux sociaux
                      pour être informé de leurs promotions et offres spéciales.
                    </div>

              </div>
              <div className="faq-box">
                <div
                  id="q3"
                  onClick={() => openQ("q3")}
                  className={`faq-box__question ${getClassQuestion("q3")}`}
                >
                  <p>3. Comment puis-je trouver des prix de location aussi bas ?</p>
                    <i className="fa-solid fa-angle-down"></i>
                    </div>

                    <div
                      id="q3"
                      onClick={() => openQ("q3")}
                      className={`faq-box__answer ${getClassAnswer("q3")}`}
                    >
                      Réservez à l’avance : réserver votre véhicule tôt permet souvent d’obtenir
                      des tarifs plus bas.  
                      Comparez les prix : utilisez des sites comme Kayak, Expedia ou Travelocity
                      pour comparer les offres de plusieurs agences.  
                      Recherchez des codes de réduction : des coupons ou codes promotionnels
                      peuvent réduire considérablement le coût de la location.  
                      Optez pour une agence hors aéroport : louer en dehors des aéroports peut
                      parfois être moins cher.
                    </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Faq;
